import React, { useState } from 'react'

const HookSystemManagementLearn = () => {
    const [value, setValue] = useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return { value, handleChange }
}

export default HookSystemManagementLearn